import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

const Container = styled(Box)<{
	occupied: boolean;
}>`
	position: relative;
	background: ${(props) => (props.occupied ? tokens.error.background : tokens.warning.background)};
	color: ${(props) => (props.occupied ? tokens.error.text : tokens.warning.text)};
`;

export default function LearningEventOccupancyWarning(props: { count: number; total: number }) {
	const { t } = useTranslation();

	return (
		<Container p={3} occupied={props.count >= props.total}>
			{props.count >= props.total
				? t('learning.event.modal.occupancyWarning.occupied', {
						count: props.count,
						total: props.total,
					})
				: t('learning.event.modal.occupancyWarning.almostReached', {
						count: props.count,
						total: props.total,
					})}
		</Container>
	);
}
